module.exports = __webpack_public_path__ + "static/media/usdt.15d1570a.svg";